// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    BellDot,
    BellElectric,
    BellMinus,
    BellOff,
    BellPlus,
    BellRing,
    BetweenHorizontalEnd,
    BetweenHorizontalStart,
    BetweenVerticalEnd,
    BetweenVerticalStart,
    BicepsFlexed,
    Bike,
    Binary,
    Binoculars,
    Biohazard,
    Bird,
    Birdhouse,
    Bitcoin,
    Blend,
    Blender,
    Blinds,
    Blocks,
    Bluetooth,
    BluetoothConnected,
    BluetoothOff,
    BluetoothSearching,
    Bold,
    Bolt,
    Bomb,
    Bone,
    BoneFracture,
    Book,
    BookA,
    BookAlert,
    BookAudio,
    BookCheck,
    BookCopy,
    BookDashed,
    BookDown,
    BookHeadphones,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "bell-dot" through "book-headphones", inclusive. */
const shard: Record<string, LucideIcon> = {
    "bell-dot": BellDot,
    "bell-electric": BellElectric,
    "bell-minus": BellMinus,
    "bell-off": BellOff,
    "bell-plus": BellPlus,
    "bell-ring": BellRing,
    "between-horizontal-end": BetweenHorizontalEnd,
    "between-horizontal-start": BetweenHorizontalStart,
    "between-vertical-end": BetweenVerticalEnd,
    "between-vertical-start": BetweenVerticalStart,
    "biceps-flexed": BicepsFlexed,
    bike: Bike,
    binary: Binary,
    binoculars: Binoculars,
    biohazard: Biohazard,
    bird: Bird,
    birdhouse: Birdhouse,
    bitcoin: Bitcoin,
    blend: Blend,
    blender: Blender,
    blinds: Blinds,
    blocks: Blocks,
    bluetooth: Bluetooth,
    "bluetooth-connected": BluetoothConnected,
    "bluetooth-off": BluetoothOff,
    "bluetooth-searching": BluetoothSearching,
    bold: Bold,
    bolt: Bolt,
    bomb: Bomb,
    bone: Bone,
    "bone-fracture": BoneFracture,
    book: Book,
    "book-a": BookA,
    "book-alert": BookAlert,
    "book-audio": BookAudio,
    "book-check": BookCheck,
    "book-copy": BookCopy,
    "book-dashed": BookDashed,
    "book-down": BookDown,
    "book-headphones": BookHeadphones,
};

export default shard;
